// START_MODULE pages_news_details_newsdetailspage_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import Spinner from 'components/atoms/spinner/Spinner';
import News from 'components/molecules/news/News';

import { INews } from 'domain/entities/INews';
import { mainRepository } from 'domain/repositories/MainRepository';

import Header from 'pages/news/Header';

const NewsDetailsPage: React.FC = () => {
  const { newsId } = useParams();

  const [news, setNews] = useState<INews>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    mainRepository.getNews(newsId!).then((news) => {
      setNews(news);
      setLoading(false);
    });
  }, []);

  if (loading) return <Spinner isCentered />;

  return (
    <>
      <Header list={false} />
      <NewsWrapper>
        <News news={news!} full />
      </NewsWrapper>
    </>
  );
};

const NewsWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 10px 30px 10px;
`;

export default NewsDetailsPage;

// END_MODULE pages_news_details_newsdetailspage_tsx
